<template>
  <div class="settings-creation-vertical">
    <UiContainer large with-actions>
      <UiTitle :title="$t('settings.creation.vertical.title')" />
      <div class="tw-mt-4 tw-flex tw-flex-col tw-gap-1">
        <v-slide-y-reverse-transition group>
          <settings-creation-block
            v-for="(vertical, index) in verticals"
            :key="`vertical ${index}`"
            :label="vertical.name"
            :subtitle="vertical.slug"
            :isOneRow="false"
            @click.native="openModalEdit(vertical)"
          />
        </v-slide-y-reverse-transition>
        <div class="tw-text-center">
          <v-btn @click="createNew" class="tw-mt-6" outlined color="#449afd">
            <v-icon class="tw-mr-2">{{ icons.mdiPlus }}</v-icon>
            {{ $t('settings.creation.vertical.create') }}
          </v-btn>
        </div>
      </div>
    </UiContainer>
    <settings-creation-modal
      :config="configModal"
      v-if="openModal === true"
      @close="openModal = false"
      @save="save"
      @update="update"
      @delete="deleteEmit"
    />
  </div>
</template>

<script>
import { mdiPlus } from '@mdi/js'
import UiContainer from '@/components/UI/Container.vue'
import UiTitle from '@/components/UI/Title.vue'
import SettingsCreationBlock from '@/components/Settings/Creation/Block.vue'
import SettingsCreationModal from '@/components/Settings/Creation/Modal.vue'

const initDefaultModal = () => ({
  mode: 'create',
  type: 'default',
  data: null,
})

export default {
  name: 'SettingsCreationVertical',
  props: {
    verticals: {
      type: Array,
      required: true,
    },
  },
  components: {
    UiContainer,
    UiTitle,
    SettingsCreationBlock,
    SettingsCreationModal,
  },
  data() {
    return {
      icons: {
        mdiPlus,
      },
      openModal: false,
      configModal: {
        ...initDefaultModal(),
      },
    }
  },
  methods: {
    createNew() {
      this.configModal = initDefaultModal()
      this.openModal = true
    },
    openModalEdit(vertical) {
      this.configModal = {
        mode: 'edition',
        type: 'default',
        data: vertical,
      }
      this.openModal = true
    },
    save(vertical) {
      this.$emit('save', vertical)
      this.openModal = false
    },
    update(vertical) {
      this.$emit('update', vertical)
      this.openModal = false
    },
    deleteEmit(vertical) {
      this.$emit('delete', vertical)
      this.openModal = false
    },
  },
}
</script>

<style lang="scss" scoped>
.settings-creation-vertical {
  @apply tw-h-full;
}
</style>
